function a(u, f) {
  const c = f ? new Set(f) : void 0, s = [];
  function i(t) {
    t.forEach((n) => {
      s.push(n), !(n.isLeaf || !n.children || n.ignored) && (n.isGroup || // normal non-leaf node
      c === void 0 || c.has(n.key)) && i(n.children);
    });
  }
  return i(u), s;
}
export {
  a as flatten
};
